import { render, staticRenderFns } from "./aside.vue?vue&type=template&id=fc654c3e&scoped=true&"
import script from "./aside.vue?vue&type=script&lang=js&"
export * from "./aside.vue?vue&type=script&lang=js&"
import style0 from "./aside.vue?vue&type=style&index=0&id=fc654c3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc654c3e",
  null
  
)

export default component.exports